import * as React from 'react'
import { createCalendar } from '@internationalized/date'
import { useCalendar } from '@react-aria/calendar'
import { useCalendarState } from '@react-stately/calendar'

import { Icon } from '@wartek-id/icon'
import { useId } from '@wartek-id/react-utils'

import styles from 'app/KinerjaShared/components/DatePicker/DatePicker.module.css'
import { CalendarGrid } from 'app/KinerjaShared/components/DatePicker/CalendarGrid'
import { CalendarMonthDropdown } from 'app/KinerjaShared/components/DatePicker/CalendarMonthDropdown'
import { CalendarYearDropdown } from 'app/KinerjaShared/components/DatePicker/CalendarYearDropdown'

import type { CalendarProps as ReactAriaCalendarProps } from '@react-aria/calendar'
import type { DateValue } from '@internationalized/date'
import type { DatePickerProps } from 'app/KinerjaShared/components/DatePicker/DatePicker'

export interface CalendarProps
  extends Pick<DatePickerProps, 'minYear' | 'maxYear'>,
    ReactAriaCalendarProps<DateValue> {}

export function Calendar(props: CalendarProps) {
  const state = useCalendarState({
    ...props,
    locale: 'id-ID',
    createCalendar,
  })

  const { calendarProps } = useCalendar(props, state as any)

  const helperId = useId()

  return (
    <div {...calendarProps} className={styles.calendarWrapper} id={helperId}>
      <div className={styles.calendarHeader}>
        <button
          data-testid="previous-page"
          aria-label="Bulan sebelumnya"
          className={styles.calendarButton}
          onClick={() => state.focusPreviousPage()}
          type="button"
        >
          <Icon>chevron_left</Icon>
        </button>
        <div className={styles.calendarHeaderTriggerWrapper}>
          <CalendarMonthDropdown state={state} />
          <CalendarYearDropdown {...props} state={state} />
        </div>
        <button
          data-testid="next-page"
          aria-label="Bulan berikutnya"
          className={styles.calendarButton}
          onClick={() => state.focusNextPage()}
          type="button"
        >
          <Icon>chevron_right</Icon>
        </button>
      </div>
      <CalendarGrid state={state} />
    </div>
  )
}
